<template>
  <div class="modal-card" id="draggable" style="width: 500px;" >    
    <header class="modal-card-head pop-header">
      <p class="modal-card-title tit">
        <span>{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
      </p>
    </header>
    <section class="modal-card-body pop-content">
      <div class="table-area">
        <div>
          <td>
            <font style="LINE-HEIGHT: 16px; font-size:9pt;">비밀번호는 도용방지와 정보유출을 방지하기 위해 자주 바꾸어 사용하시거나 세심한 관리가 필요합니다. 비밀번호 변경시에는 타인이 알아내기 쉬운 번호는 사용을 피하시기 바랍니다.   
              <font color="#FF0000">특히 담당자가 퇴사하거나 변경시 반드시 새로운 암호로 변경 하여 주시기 바랍니다.</font><br>
              비밀번호는 영문 또는 숫자를 섞어서 6자리 이상 10자리 이하로 만들수 있으며, 비밀번호 보호를 위해 반드시 영문 또는 특수문자 1자 이상을 포함시키시기 바랍니다.
            </font>
          </td>
        </div>
        <br>
        <div>
          <td>
            <font face="Arial" size="2" color="#0000FF">
              To change password, type your user ID and password(Current & New) 
            </font>
          </td>
        </div>
        <br>
        <div class="table-a">
          <div class="table-name">
            <h3 class="ico_table_name">Change Password</h3>
          </div>
          <table class="table">
            <colgroup>
              <col width="20%;">
              <col width="80%;">
            </colgroup>
            <tbody>
              <tr>
                <th>User ID</th>
                <td><input class="modal-input" type="text" v-model="form.userId" :disabled="!this.$store.state.loginInfo.isAdmin"></td>
              </tr>                        
              <tr>
                <th>Current Password</th>
                <td><input class="modal-input" type="password" v-model="form.currentPw"></td>
              </tr>
              <tr>
                <th>New Password</th>
                <td><input class="modal-input" type="password" v-model="form.newPw"></td>
              </tr>
              <tr>
                <th>Verify Password</th>
                <td><input class="modal-input" type="password" v-model="form.verifyPw"></td>
              </tr>                        
            </tbody>
          </table>
        </div>
      </div>
      <div class="btn-type2">
        <button class="btn-size btn-w-gray" @click="changeButton">Change</button>
        <button class="btn-size btn-w-gray" style="margin-left: 5px;" @click="resetButton">Reset</button>
      </div>
    </section>
  </div>
</template>
<script>
import mixin from '@/mixin';

export default {
  name: 'ChangePwdPop',
  components: {
  },
  mixins: [ mixin ],
  /* eslint-disable */
  props: ['param'],
  data() {
    return {
      title: '비밀번호 변경',
      form: {
        userId: '',
        currentPw: '',
        newPw: '',
        verifyPw: '',
      },
    }
  },
  mounted() {
    //pop slots modal move
    $(".animation-content").draggable({'cancel':'.modal-card-body'});

    if(!this.$store.state.loginInfo.isAdmin){
      this.form.userId = this.$store.state.loginInfo.loginId;
    }
  },
  methods: {
    create(){
    },
    closeModal() {
      this.$parent.close();
    },
    changeButton(){
       if(this.changePreCheck()) this.change();
    },
    changePreCheck(){

      //프리폼 필수 입력 체크
      if(!this.form.userId){
        this.$swal({ type: 'warning', text: 'Uesr ID 입력 바랍니다.' })
        //alert('Please Enter Uesr ID !!')
        return false;
      }

      //관리자의 경우 현재 패스워드 체크 필요 하지 않음
      if(!this.$store.state.loginInfo.isAdmin){
        if(!this.form.currentPw){
          this.$swal({ type: 'warning', text: 'Current Password 입력 바랍니다.' })
          //alert('Please Enter Current Password !!')
          return false;
        }
      }

      if(!this.form.newPw){
        this.$swal({ type: 'warning', text: 'New Password 입력 바랍니다.' })
        //alert('Please Enter New Password !!')
        return false;
      }
      
      if(!this.form.verifyPw){
        this.$swal({ type: 'warning', text: 'Verify Password 입력 바랍니다.' })
        //alert('Please Enter Verify Password !!')
        return false;
      }

    if( this.form.newPw != this.form.verifyPw){
      this.$swal({ type: 'warning', text: 'New Password 와 Verify Password가 일치 하지 않습니다.' })
      //alert("New Password and Verify Password not the same !!");
      return false;
    }	      

    if( this.form.currentPw === this.form.newPw){
      this.$swal({ type: 'warning', text: 'New Password 와 Current Password 같을 수 없습니다.' })
      //alert("New Password cann't be same as Current Password !!");
      return false;
    }	
      if( this.form.newPw.length < 6){
      this.$swal({ type: 'warning', text: '6자리 이상 패스워드 입력 바랍니다.' })
      //alert("Password less than 6 chacters !!");
      return false;
    }	    
      
      return true;
    },
    change(){
      let vm = this

      this.$swal({
          type: 'warning',
          text: `패스워드 변경 하시겠습니까?`,
          showCancelButton: true,
          confirmButtonText: '예',
          cancelButtonText: '아니오',
        }).then((result) => {
          
          if (result.value) {
            this.$store.commit('loading') 
            this.$http.post(`/api/common/change/password`, JSON.parse(JSON.stringify(vm.form)))
              .then((response) => {
                  this.$swal({type: 'success', text: '변경 되었습니다.'})
              })
              .catch((e) => {
                  this.$swal({type: 'error', text: e.response.data.message});
              }).finally(() => {
                  this.$store.commit('finish');
              });
          }
        });
    } ,   
    resetButton(){
      //초기화
      this.form =  {         
        userId: !this.$store.state.loginInfo.isAdmin ? this.$store.state.loginInfo.loginId: '',
        currentPw: '',
        newPw: '',
        verifyPw: ''
      };
    },    
  },
};
</script>

<style>

.modal-card-head {background: #0065b3;}
.modal-card-title {color:white; font-size:1.2em;}
.modal-close {top: 80px;}

.modal-input {
  width: 100%;
}
</style>
